import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { getUuid } from '@sibe/utilities/common';
import {
  HsGraphicObject,
  HsMatrix4,
  HsQuaternion,
  HsVector3,
  hsGenerateCubeGeometryData,
  hsIndexGeometry,
  hsMakeIndexedGeometry,
  type HsHypersceneViewer,
  type HsIndexedGeometry,
} from '@sibe/hyperscene';
import { DemoViewerPage } from '../../classes/demo-viewer-page.class';
import { makeLitMaterial } from '../../functions/make-lit-material.function';

const ROTATION: HsMatrix4 = HsMatrix4.compose(
  [0, 0, 0],
  HsQuaternion.makeFromAxisAndAngle(new HsVector3(1, 0.5, 0.25).normalize().values, 0.01).values,
  [1, 1, 1]
);

/** A rotating cube built from indexed geometry. */
@Component({
  selector: 'indexed-mesh-object',
  templateUrl: './indexed-mesh-object.component.html',
  styleUrls: ['./indexed-mesh-object.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IndexedMeshObject extends DemoViewerPage {
  private cube: HsGraphicObject | null = null;

  protected initScene(viewer: HsHypersceneViewer): void {
    const geometry: HsIndexedGeometry | null = hsMakeIndexedGeometry(
      viewer.surface.graphics,
      hsIndexGeometry(hsGenerateCubeGeometryData())
    );
    if (geometry === null) {
      return;
    }
    this.cube = new HsGraphicObject(getUuid(), 'cube', geometry, makeLitMaterial(viewer.gl, 1, 0.5, 0.25));
    this.cube.updateBoundingSphere();
    viewer.add(this.cube);
    viewer.camera.worldMatrix.setPosition([0, 0, 5]);
  }

  protected override animate(): boolean {
    this.cube?.worldMatrix.multiply(ROTATION);
    return this.cube !== null;
  }
}
